import { Icon, IconProps } from '@chakra-ui/react';

export function SyncDisabled(props: IconProps): JSX.Element {
  return (
    <Icon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.71563 4.72493V2.98327C8.16563 3.12494 7.64063 3.3416 7.14896 3.60827L8.39896 4.85827C8.50729 4.8166 8.60729 4.7666 8.71563 4.72493ZM17.049 9.43327C17.049 7.5916 16.2906 5.93327 15.0823 4.73327L17.049 2.7666H12.049V7.7666L13.9156 5.89994C14.8156 6.80827 15.3823 8.04993 15.3823 9.43327C15.3823 10.1416 15.224 10.8083 14.9573 11.4166L16.2073 12.6666C16.7406 11.7166 17.049 10.6083 17.049 9.43327ZM3.94063 2.7666L2.76562 3.9416L4.73229 5.90827C4.09062 6.92493 3.71563 8.13327 3.71563 9.43327C3.71563 11.2749 4.47396 12.9333 5.68229 14.1333L3.71563 16.0999H8.71563V11.0999L6.84896 12.9666C5.94896 12.0583 5.38229 10.8166 5.38229 9.43327C5.38229 8.59993 5.59063 7.8166 5.94896 7.12493L12.6823 13.8583C12.474 13.9666 12.2656 14.0583 12.049 14.1416V15.8833C12.7156 15.7083 13.3406 15.4333 13.9073 15.0833L16.0573 17.2333L17.2323 16.0583L3.94063 2.7666Z"
        fill="currentColor"
      />
    </Icon>
  );
}
